export {ContentDataManagerComponent} from './content-data-manager.component';
